<template>
  <div
    v-if="
      ['sent', 'open'].includes(paymentLinkStatus) && paymentStatus === 'UNPAID'
    "
  >
    <el-tooltip content="Copy Payment Link" placement="bottom">
      <div :class="classes">
        <span
          :class="
            getClassByStatusPayment(
              paymentStatus,
              paymentMethod,
              paymentLinkStatus
            )
          "
        >
          {{ getStatusPayment(paymentMethod, paymentStatus) }}
        </span>
        <span
          class="d-block f-10"
          v-clipboard:copy="paymentLink"
          v-clipboard:success="copyPaymentLink"
          v-clipboard:error="onErrorCopyPaymentLink"
        >
          {{ getContentByStatusPayment(paymentStatus, paymentLinkStatus) }}
          <i class="flaticon-copy"></i>
        </span>
      </div>
    </el-tooltip>
  </div>

  <div v-else :class="classes">
    <span
      :class="
        getClassByStatusPayment(paymentStatus, paymentMethod, paymentLinkStatus)
      "
    >
      {{ getStatusPayment(paymentMethod, paymentStatus) }}
    </span>
    <span class="d-block f-10">
      {{ getContentByStatusPayment(paymentStatus, paymentLinkStatus) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PaymentStatus",
  props: {
    paymentMethod: {
      type: String,
      default: null,
      description: "Payment method of the reservation"
    },
    paymentStatus: {
      type: String,
      default: "UNPAID",
      description: "Payment status of the reservation"
    },
    paymentLink: {
      type: String,
      default: "pending",
      description: ""
    },
    paymentLinkStatus: {
      type: String,
      default: "pending",
      description: ""
    },
    classes: {
      type: String,
      default: "",
      description: "class of the text"
    }
  },
  data() {
    return {
      paidStatus: ["PAID", "PARTIALLY_PAID"],
      refundedStatus: ["REFUNDED", "PARTIALLY_REFUNDED"]
    };
  },
  methods: {
    getStatusPayment(paymentMethod, paymentStatus) {
      if (paymentStatus === "PAID") {
        return paymentMethod === "CREDIT" ? "On Credit" : "Paid";
      }

      if (paymentStatus === "PARTIALLY_PAID") {
        return "Partially Paid";
      }

      if (paymentStatus === "REFUNDED") {
        return "Refunded";
      }

      if (paymentStatus === "PARTIALLY_REFUNDED") {
        return "Partially Refunded";
      }

      return "Unpaid";
    },
    getIconByStatusPayment(paymentStatus, paymentLinkStatus) {
      const isPaid = ["PAID", "PARTIALLY_PAID"].includes(paymentStatus);
      const isRefunded = ["REFUNDED", "PARTIALLY_REFUNDED"].includes(
        paymentStatus
      );

      if (isPaid || isRefunded) {
        if (isRefunded) return "flaticon-money-back-guarantee danger";
        return "";
      }

      if (paymentLinkStatus === "sent") {
        return "flaticon-email";
      } else if (paymentLinkStatus === "open") {
        return "flaticon-visualization";
      } else if (paymentLinkStatus === "expired") {
        return "flaticon-clock";
      }
      return "";
    },
    getContentByStatusPayment(paymentStatus, paymentLinkStatus) {
      const isPaid = ["PAID", "PARTIALLY_PAID"].includes(paymentStatus);
      const isRefunded = ["REFUNDED", "PARTIALLY_REFUNDED"].includes(
        paymentStatus
      );

      if (isPaid || isRefunded) {
        if (isRefunded) return "Refunded";
        return "";
      }

      if (paymentLinkStatus === "sent") {
        return "Link Sent";
      } else if (paymentLinkStatus === "open") {
        return "Link Viewed";
      } else if (paymentLinkStatus === "expired") {
        return "Link Expired";
      }

      return "";
    },
    getClassByStatusPayment(paymentStatus, paymentMethod, paymentLinkStatus) {
      const isPaid = ["PAID", "PARTIALLY_PAID"].includes(paymentStatus);
      const isRefunded = ["REFUNDED", "PARTIALLY_REFUNDED"].includes(
        paymentStatus
      );
      if (isPaid || isRefunded) {
        if (isPaid) {
          return paymentMethod === "CREDIT"
            ? "text-warning status-paid"
            : "text-success";
        }
        return "text-processing status-paid";
      }

      if (paymentLinkStatus === "pending") {
        return "text-danger";
      }

      return "text-warning status-paid";
    },
    getPaymentLinkStatus(paymentStatus, paymentLink) {
      const isPaid = ["PAID", "PARTIALLY_PAID"].includes(paymentStatus);
      const isRefunded = ["REFUNDED", "PARTIALLY_REFUNDED"].includes(
        paymentStatus
      );
      if (isPaid || isRefunded) {
        if (isRefunded) return "Refund";
        return "Paid";
      }

      if (paymentLink === "sent") {
        return "Link Sent";
      } else if (paymentLink === "open") {
        return "Link Viewed";
      } else if (paymentLink === "expired") {
        return "Link Expired";
      }

      return "Unpaid";
    },
    copyPaymentLink() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The payment link has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopyPaymentLink() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The payment link could not be copied",
        icon: "flaticon-remove"
      });
    }
  }
};
</script>
